<mat-label class="subHeading">Payout Base<span class="star">*</span></mat-label>
<mat-select formControlName="payout_base" class="payout" placeholder="All">
    <mat-option *ngFor="let payoutBase of payoutBaseTypes" [value]="payoutBase.value">{{payoutBase.name}}</mat-option>
</mat-select>